export default {
  activities: [],
  getActivitiesRequest: false,
  getActivitiesSuccess: false,
  getActivitiesFailed: false,
  getActivitiesErrors: null,
  activityPollInterval: null,

  deleteActivityRequest: false,
  deleteActivitySuccess: false,
  deleteActivityFailed: false,
  deleteActivityErrors: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/activities/state.js